import React from "react";

export default function Page404(){
    
    return(
        <>
        <h1>Pagina nao encontrada</h1>
        </>
    )
}